module.exports = __webpack_public_path__ + "img/com_ESDM.49eb53d9.png";